export default __webpack_public_path__ + "static/media/sunspotsActive.7e5a9bcc.svg";